import { Col, Row, Space, Tag, Typography, message } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { IPayoutRequest } from "../../helpers/types";
import dayjs from "dayjs";
import SpinnerComponent from "../SpinnerComponent/SpinnerComponent";
import TouchGif from "../../assets/gif/touch.gif";
import { payoutRequestService } from "../../services/payoutRequest.service";
import "./index.less";

type props = {
  list?: IPayoutRequest[];
  sentryRef: any;
  loading: boolean;
  hasMore: boolean;
  showGif?: boolean;
};

const CreatorPaymentHistoryPaymentTabComponent: React.FC<props> = ({ list, sentryRef, loading, hasMore, showGif = false }) => {
  const { t } = useTranslation();
  const [downloadingId, setDownloadingId] = useState<string | null>(null);

  const handleDownloadInvoice = async (payoutId: string, refId: string) => {
    if (!payoutId) return;

    setDownloadingId(payoutId);
    try {
      const response = await payoutRequestService.downloadInvoice(payoutId);
      if (response) {
        const byteArray = new Uint8Array(response);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `${refId}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        message.success(t("invoice-downloaded-successfully") || "Invoice downloaded successfully");
      }
    } catch (error) {
      message.error(t("failed-to-download-invoice") || "Failed to download invoice");
    } finally {
      setDownloadingId(null);
    }
  };

  return (
    <>
      {list === undefined || list.length === 0 ? (
        <Col className="not-payment-text">{t("no-payment-has-been-made")}</Col>
      ) : (
        <div className="payment-container">
          {list &&
            list.map((item, index) => {
              return (
                <div
                  className={`payment-row ${index === 0 && showGif ? "first-row-with-gif" : ""} ${downloadingId === item._id ? "downloading" : ""}`}
                  key={index}
                  onClick={() => item._id && item.refId && handleDownloadInvoice(item._id, item.refId)}
                  style={{ cursor: downloadingId === item._id ? "wait" : "pointer" }}
                >
                  {index === 0 && showGif && <img src={TouchGif} alt="touch" className="touch-gif" />}
                  <Space>
                    <Tag className="tag">{item.refId}</Tag>
                    <Typography.Text className="font-12-regular text-grey-color">{dayjs(item.createdAt).format("DD MMMM YYYY")}</Typography.Text>
                  </Space>
                  <Typography.Text className="font-13-bold text-white-color">
                    {item.netprice?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}{" "}
                    €
                  </Typography.Text>
                </div>
              );
            })}
          {(loading || hasMore) && <SpinnerComponent refProp={sentryRef} />}
        </div>
      )}
    </>
  );
};

export default CreatorPaymentHistoryPaymentTabComponent;
